import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes - standard default
      gcTime: 1000 * 60 * 30, // 30 minutes - standard cache retention
      retry: 2, // Retry failed requests twice
      refetchOnWindowFocus: false, // Prevent background refetches for better UX
      refetchOnMount: true, // Refetch when component mounts if data is stale
      refetchOnReconnect: true, // Refetch when network reconnects if data is stale
    },
    mutations: {
      retry: 1,
    },
  },
});

// Set query-specific defaults using TanStack Query's standard approach
queryClient.setQueryDefaults(['products'], {
  staleTime: 1000 * 60 * 2, // 2 minutes for search results
  gcTime: 1000 * 60 * 10, // 10 minutes garbage collection
});

queryClient.setQueryDefaults(['attributes'], {
  staleTime: 1000 * 60 * 15, // 15 minutes for attributes
  gcTime: 1000 * 60 * 30, // 30 minutes garbage collection
});

queryClient.setQueryDefaults(['facets'], {
  staleTime: 1000 * 60 * 15, // 15 minutes for facets
  gcTime: 1000 * 60 * 20, // 20 minutes garbage collection
});

queryClient.setQueryDefaults(['indexes'], {
  staleTime: 1000 * 60 * 30, // 30 minutes for indexes (rarely change)
  gcTime: 1000 * 60 * 60, // 1 hour garbage collection
});

queryClient.setQueryDefaults(['salesOrgs'], {
  staleTime: 1000 * 60 * 30, // 30 minutes for sales orgs (rarely change)
  gcTime: 1000 * 60 * 60, // 1 hour garbage collection
});
